// @flow

import type { FetchResponse } from '@gandi/resource/redux';

import { GET } from 'gandi.redux-fetcher';

import type { Dispatch, ThunkAction } from '../../../types';
import type { Fallback } from '../../types';

const fetchRenewable =
  (fqdn: string): (Dispatch => any) =>
  dispatch =>
    dispatch(
      GET(`/domain-anonymous/domains/${fqdn}/renew`, {
        on200: (response: FetchResponse<>) => response,
        // $FlowFixMe[incompatible-call]
        not200: (response: FetchResponse<>) => response,
      }),
    );

const fetchRestorable =
  (fqdn: string): (Dispatch => Promise<mixed>) =>
  async dispatch =>
    dispatch(
      GET(`/domain-anonymous/domains/${fqdn}/restore`, {
        on200: (response: FetchResponse<>) => response,
        // $FlowFixMe[incompatible-call]
        not200: (response: FetchResponse<>) => Promise.reject(response),
      }),
    );

const fetchTransferable =
  (fqdn: string): (Dispatch => any) =>
  dispatch =>
    dispatch(
      GET(`/domain-anonymous/transferin/${fqdn}/available`, {
        on200: (response: FetchResponse<>) => response,
        // $FlowFixMe[incompatible-call]
        not200: (response: FetchResponse<>) => Promise.reject(response),
      }),
    );

type FetchFallbackReturn = Promise<Fallback>;
type FetchFallback<R> = (fqdn: string) => R;
export type FetchFallbackBoundAction = FetchFallback<FetchFallbackReturn>;
export type FetchFallbackThunkAction = FetchFallback<
  ThunkAction<FetchFallbackReturn>,
>;

/**
 * For an unavailable domain search result\
 * Attempt in best-effort manner to determine whether the given domain
 * can be renewed / restored or transfered.
 */
export const fetchFallback: FetchFallbackThunkAction =
  fqdn => async dispatch => {
    let renewable = false;
    let restorable = false;
    let transferable = false;
    let invalid = false;

    try {
      const renew = await dispatch(fetchRenewable(fqdn));
      if (renew.status === 400) {
        invalid = true;
      }

      if (renew.status === 404) {
        const transfer = await dispatch(fetchTransferable(fqdn));
        if (transfer.data.available) {
          transferable = true;
        }
      }

      if (renew.status === 200) {
        // T54746
        const data = renew.data.renew || renew.data;
        if (
          data.renewable &&
          data.in_renew_period &&
          // T54746
          ('renewable' in data ? data.renewable : true) &&
          !data.prohibited &&
          data.durations.length > 0
        ) {
          renewable = true;
        } else {
          const restore = await dispatch(fetchRestorable(fqdn));
          if (restore.data.restorable) {
            restorable = true;
          }
        }
      }
    } catch (err) {
      /* pass */
    }

    return {
      renewable,
      restorable,
      transferable,
      invalid,
    };
  };
